module.exports = __webpack_public_path__ + "img/05—Applications.8c06cbde.jpg";